type SearchParamsSnapshot = { toString(): string } | null;

export function cloneSearchParams(
  searchParams: SearchParamsSnapshot
): URLSearchParams {
  return new URLSearchParams(searchParams?.toString() ?? "");
}

export function deleteSearchParams(
  searchParams: URLSearchParams,
  names: readonly string[]
): URLSearchParams {
  for (const name of names) searchParams.delete(name);
  return searchParams;
}

export function buildPathWithSearchParams(
  pathname: string,
  searchParams: URLSearchParams
): string {
  const search = searchParams.toString();
  return search ? `${pathname}?${search}` : pathname;
}
